/**
 * Shared auth utilities for API calls to our backend.
 *
 * Prefers JWT (signed-in users) over legacy x-auth-token headers.
 * Non-React code (tts.ts, upload/index.ts) can use these without hooks.
 */

const JWT_STORAGE_KEY = 'talkyn-auth-jwt';

/**
 * Get auth headers for API calls to our backend.
 * Prefers JWT (for signed-in users), falls back to legacy token.
 */
export function getApiAuthHeaders(legacyTokenKey?: string): Record<string, string> {
  // JWT takes priority when user is signed in
  const jwt = localStorage.getItem(JWT_STORAGE_KEY);
  if (jwt) return { Authorization: `Bearer ${jwt}` };

  // Fall back to legacy token for non-signed-in users
  if (legacyTokenKey) {
    const token = localStorage.getItem(legacyTokenKey);
    if (token) return { 'x-auth-token': token };
  }
  return {};
}

/**
 * Check if any auth is available (JWT or legacy token).
 */
export function hasAnyAuth(legacyTokenKey?: string): boolean {
  return Object.keys(getApiAuthHeaders(legacyTokenKey)).length > 0;
}
